export default "__VITE_ASSET__CfSboR7o__"